module.exports = __webpack_public_path__ + "img/icon-pasivno_hladi_mod.png";